import { Component, Input } from '@angular/core';
import { getLLCAddressShort } from '@core/util/address';
import { Branch } from '@models/llc-mortgages';
import { ICON } from '@core/util/icon';

@Component({
	selector: 'app-llc-contact-card',
	templateUrl: './contact-card.component.html',
	standalone: false,
})
export class LLCContactCardComponent {
	public contactFirstName = '';
	public contactLastName = '';
	public contactPhone = '';
	public contactEmail = '';
	public ICON = ICON;
	public name;
	public address;

	@Input() set contact(contact: Branch) {
		this.name = contact?.name;
		this.address = getLLCAddressShort(contact?.address);
		this.contactFirstName = contact?.firstName;
		this.contactLastName = contact?.lastName;
		this.contactPhone = contact?.phone;
		this.contactEmail = contact?.email;
	}

	@Input() type: 'branch' | 'center';
}
